import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({
  children,
  t,
  language,
  setLanguage,
  mainLogo,
  navbarLogo,
}) {
  return (
    <>
      <Navbar
        logo={navbarLogo}
        t={t}
        language={language}
        setLanguage={setLanguage}
      />

      {children}

      <Footer logo={mainLogo} t={t} language={language} />
    </>
  );
}